module.exports = __webpack_public_path__ + "img/01300d5.png";